/**
 * Leaf constant for the add-on Account modal's query marker (`?context=account-management`).
 *
 * Lives apart from `constants/App` on purpose: that module imports `services/env`, which reads
 * `window` at load. `services/framedSurface` (and through it `router-compat`) needs only this
 * value, so keeping it here lets node-environment suites import those without a DOM.
 */
export const ACCOUNT_MANAGEMENT_CONTEXT = 'account-management'
